import { createFileRoute } from '@tanstack/react-router';
import { MasterObligationAIRelated } from './MasterObligationAIRelated';

export const Route = createFileRoute('/admin-console/platform-content/obligations/library/details/$id/ai-related')({
    component: () => <MasterObligationAIRelated />,
});
